import React, { useEffect, useState } from "react";
import {
  Button,
  Input,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import { toast } from "react-toastify";
import {
  createChildSubTask,
  getTeammember,
  getUserProfile,
} from "../../Api/ApiUrlConst";

interface TeamMember {
  userId: string;
  userName: string;
  department: string; // ✅ correct field
}

interface Props {
  subTaskId: number;
  parentSubTaskDueDate: string;
  onCreated: () => void;
  onCancel: () => void;
}

const AddChildSubTaskInline: React.FC<Props> = ({
  subTaskId,
  parentSubTaskDueDate,
  onCreated,
  onCancel,
}) => {
  const [loading, setLoading] = useState(false);
  const [loadingMembers, setLoadingMembers] = useState(false);

  const [teamMembers, setTeamMembers] = useState<TeamMember[]>([]);
  const [memberModalOpen, setMemberModalOpen] = useState(false);
  const [tempMemberIds, setTempMemberIds] = useState<string[]>([]);

  const loginUserDept = localStorage.getItem("department") || "";

  const MODELLING_STATUSES = [
    { value: "NotApplicable", label: "Not In Scope" },

  { value: "YetToStart", label: "Yet to Start" },
  { value: "InProgress", label: "In Progress" },
  { value: "OnHold", label: "On Hold" },
  { value: "ReadyForReview", label: "Ready for Review" },
  { value: "ReviewInProgress", label: "Review in Progress" },
  { value: "ChangesRequested", label: "Changes Requested" },
  { value: "ReworkCorrectionInProgress", label: "Rework / Correction in Progress" },
  { value: "CompletedAndApproved", label: "Completed & Approved" },
];

const DRAFTING_STATUSES = [
    { value: "NotApplicable", label: "Not In Scope" },

  { value: "YetToStart", label: "Yet to Start" },
  { value: "InProgress", label: "In Progress" },
  { value: "OnHold", label: "On Hold" },
  { value: "ReadyForReview", label: "Ready for Review" },
  { value: "ReviewInProgress", label: "Review in Progress" },
  { value: "ReworkCorrectionInProgress", label: "Rework / Correction in Progress" },
  { value: "ReadyToRelease", label: "Ready to Release" },
  { value: "CompletedAndReleased", label: "Completed" },
];

const DEFAULT_STATUSES = [
  { value: "NotApplicable", label: "Not In Scope" },
  { value: "YetToStart", label: "Yet to Start" },
  { value: "OnHold", label: "On Hold" },
  { value: "InProgress", label: "In Progress" },
];

  const [form, setForm] = useState({
    description: "",
    dueDate: "",
    status: "YetToStart",
    priority: "Medium",
    percentCompleted: 0,
    maxHours: 0,
    teamMemberIds: [] as string[],
  });

  // ================= FETCH TEAM MEMBERS =================
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoadingMembers(true);

        const profileRes = await getUserProfile();

        // save login user department if not already saved
        if (profileRes.data?.department) {
          localStorage.setItem("department", profileRes.data.department);
        }

        const tmRes = await getTeammember();
        const membersData = tmRes.data?.$values || tmRes.data || [];

        setTeamMembers(
          membersData.map((tm: any) => ({
            userId: String(tm.userID),
            userName: tm.name,
            department: tm.department, // ✅ correct mapping
          }))
        );
      } catch (err) {
        console.error("Error loading team members:", err);
      } finally {
        setLoadingMembers(false);
      }
    };

    fetchData();
  }, []);

  // ================= FILTER BY DEPARTMENT =================
  const filteredMembers = teamMembers.filter(
    (m) =>
      m.department?.trim().toLowerCase() ===
      loginUserDept.trim().toLowerCase()
  );

  // ================= SUBMIT =================
  const handleSubmit = async () => {
    if (!form.description || !form.dueDate) {
      toast.error("Description & Due Date required");
      return;
    }

    if (new Date(form.dueDate) >= new Date(parentSubTaskDueDate)) {
      toast.error("Child task due date must be before subtask due date");
      return;
    }

    if (!form.teamMemberIds.length) {
      toast.error("Select at least one team member");
      return;
    }

    setLoading(true);
    try {
      await createChildSubTask({
        subTaskId,
        ...form,
      });

      toast.success("Child SubTask created");
      onCreated();
    } catch (err: any) {
      toast.error(err?.response?.data?.message || "Failed to create child task");
    } finally {
      setLoading(false);
    }
  };
  const getStatusOptions = () => {
  const desc = form.description.toLowerCase();

  if (desc.includes("modelling")) {
    return MODELLING_STATUSES;
  }

  if (desc.includes("drafting")) {
    return DRAFTING_STATUSES;
  }

  return DEFAULT_STATUSES;
};
useEffect(() => {
  const options = getStatusOptions();

  if (!options.find(o => o.value === form.status)) {
    setForm(p => ({
      ...p,
      status: options[0].value, // default to first valid status
    }));
  }
}, [form.description]);

  return (
    <>
      <div className="d-flex">
        <td style={{ marginLeft: "150px" }}>
          <Input
            placeholder="Child task description"
            value={form.description}
            onChange={(e) =>
              setForm({ ...form, description: e.target.value })
            }
            style={{ width: "400px" }}
          />
        </td>

        <td>
          <Button
            size="sm"
            color="secondary"
            disabled={loadingMembers}
            onClick={() => {
              setTempMemberIds(form.teamMemberIds);
              setMemberModalOpen(true);
            }}
            style={{ width: "250px" }}
          >
            {loadingMembers
              ? "Loading..."
              : form.teamMemberIds.length
              ? `${form.teamMemberIds.length} Selected`
              : "Select Members"}
          </Button>
        </td>

         <td>
         <Input
  type="select"
  value={form.status}
  onChange={(e) =>
    setForm({ ...form, status: e.target.value })
  }
  style={{ width: "280px" }}
>
  {getStatusOptions().map(opt => (
    <option key={opt.value} value={opt.value}>
      {opt.label}
    </option>
  ))}
</Input>

        </td>
        

        <td>
          <Input
            type="date"
            value={form.dueDate}
            max={parentSubTaskDueDate}
            onChange={(e) =>
              setForm({ ...form, dueDate: e.target.value })
            }
             style={{width:"250px"}}
          />
        </td>
         <td>
          <Input
            type="select"
            value={form.priority}
            onChange={(e) =>
              setForm({ ...form, priority: e.target.value })
            }
             style={{width:"250px"}}
          >
             <option value="Low">Low</option>
  <option value="Medium">Medium</option>
  <option value="High">High</option>
  <option value="Critical">Critical</option>
          </Input>
        </td>

       

      

        <td className="d-flex gap-2">
          <Button size="sm" color="success" onClick={handleSubmit}>
            {loading ? <Spinner size="sm" /> : "Save"}
          </Button>
          <Button size="sm" color="secondary" onClick={onCancel}>
            Cancel
          </Button>
        </td>
      </div>

      {/* ================= MEMBER MODAL ================= */}
      <Modal isOpen={memberModalOpen} toggle={() => setMemberModalOpen(false)}>
        <ModalHeader toggle={() => setMemberModalOpen(false)}>
          Select Team Members ({loginUserDept})
        </ModalHeader>

        <ModalBody>
          {loadingMembers ? (
            <div className="text-center">
              <Spinner size="sm" />
            </div>
          ) : filteredMembers.length === 0 ? (
            <div className="text-center text-danger">
              No members found for your department
            </div>
          ) : (
            filteredMembers.map((m) => (
              <div key={m.userId} className="form-check mb-2">
                <Input
                  type="checkbox"
                  checked={tempMemberIds.includes(m.userId)}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setTempMemberIds((p) => [...p, m.userId]);
                    } else {
                      setTempMemberIds((p) =>
                        p.filter((id) => id !== m.userId)
                      );
                    }
                  }}
                />
                <label className="ms-2">
                  {m.userName} 
                </label>
              </div>
            ))
          )}

          <div className="d-flex justify-content-end gap-2 mt-3">
            <Button
              size="sm"
              color="primary"
              onClick={() => {
                setForm((p) => ({
                  ...p,
                  teamMemberIds: tempMemberIds,
                }));
                setMemberModalOpen(false);
              }}
            >
              Save
            </Button>

            <Button
              size="sm"
              color="secondary"
              onClick={() => setMemberModalOpen(false)}
            >
              Cancel
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default AddChildSubTaskInline;
